import {ChampionshipReignMatchesHash, Championships, Matches, Superstars} from "./models.js";

function ChampionshipReign(startMonth, startYear) {
    // Booleans
    const vacated = false;
    const retired = false;

    // Integer
    const endMonth = null;
    const endYear = null;

    // Strings
    const holderName = null;

    // Foreign keys
    const championshipId = null;
    const superstarId = null;

    return {
        startMonth,
        startYear,
        vacated,
        retired,
        endMonth,
        endYear,
        holderName,
        championshipId,
        superstarId,
    };
}

function getChampionshipReignSuperstar(championshipReign) {
    if (championshipReign.superstarId) {
        return Superstars.find({'$loki': championshipReign.superstarId})[0];
    }
    else {
        return null;
    }
}

function getChampionshipReignChampionship(championshipReign) {
    if (championshipReign.championshipId) {
        return Championships.find({'$loki': championshipReign.championshipId})[0];
    }
    else {
        return null;
    }
}

async function getChampionshipReignMatches(championshipReign) {
    const championshipReignMatchHashes = ChampionshipReignMatchesHash.find({'championshipReignId': championshipReign.$loki});
    const matchIds = championshipReignMatchHashes.map(x => {
        return x.matchId
    });
    return Matches.find({'$loki': {'$in': matchIds}});
}

export { ChampionshipReign, getChampionshipReignChampionship, getChampionshipReignMatches, getChampionshipReignSuperstar }
